export default "__VITE_ASSET__ii7h8HIF__"